import { HttpService } from "@root/services/http";
import { addQueryToUrl } from "@root/utils/helpers";
import { WEB_TABLES_MAX_LIMIT } from "@root/webConstants";
import {
  ADMIN_CREATE_USER_ENDPOINT,
  ADMIN_GET_USER_BY_ID_ENDPOINT,
  ADMIN_USER_ADD_ENDPOINT,
  ADMIN_USER_MANAGEMENT_ENDPOINT,
} from "../endPoints";

const formatDate = (date: Date | string): string => {
  if (!date) return "";
  return new Date(date).toISOString().split("T")[0]; // "YYYY-MM-DD"
};

export class AdminUserMangement extends HttpService {
  fetchAdminUsers = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const { searchQuery, page, limit, start_date, end_date, status } = payload;

    const baseUrl = `${baseAuthUrl}/${ADMIN_USER_MANAGEMENT_ENDPOINT}`;

    // Build query params dynamically
    const params = new URLSearchParams();

    if (searchQuery) params.append("searchQuery", searchQuery);
    if (page) params.append("page", page.toString());
    if (limit) params.append("limit", limit.toString());
    if (status !== undefined && status !== "")
      params.append("status", String(status));
    if (start_date) params.append("start_date", formatDate(start_date));
    if (end_date) params.append("end_date", formatDate(end_date));

    const url = `${baseUrl}?${params.toString()}`;

    try {
      const apiResponse = await this.get(url);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  AddUser = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const baseUrl = `${baseAuthUrl}/${ADMIN_USER_ADD_ENDPOINT}`;
    const url = addQueryToUrl(baseUrl, payload);
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
  fetchAdminUserByID = async (
    baseAuthUrl: string,
    payload: any
  ): Promise<any> => {
    const { userId } = payload;

    try {
      const url = `${baseAuthUrl}/${ADMIN_GET_USER_BY_ID_ENDPOINT}/${userId}`;
      const apiResponse = await this.get(url);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
  createUser = async (baseAuthUrl: string, payload: any): Promise<any> => {
    try {
      const url = `${baseAuthUrl}/${ADMIN_CREATE_USER_ENDPOINT}`;
      const apiResponse = await this.post(url, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
